import React, { useState } from "react";
import "./reiniciopass.css";
import { Link } from "react-router-dom";
import { Button, Header, Label } from "semantic-ui-react";
import { ErrorMessage, Form, Formik } from "formik";
import MyTextInput from "../app/common/form/MyTextInput";
import { useStore } from "../app/stores/store";
import { observer } from "mobx-react-lite";
import RegisterForm from "../features/users/RegisterForm";
import * as Yup from "yup";
import { ResetPassMod, ResetPassModFormValues } from "../app/models/PassWord";
import { toast } from "react-toastify";
import LoadingComponent from "../app/layout/LoadingComponent";
import { useHistory } from "react-router-dom";
export default observer(function ReinicioPass() {
  const { userStore } = useStore();
  const {
    userStore: { user, logout, isLoggedIn, roles, loadNotificar },
    SGPersonaStore: { SGPersonaByName, loadSGPersona },
    modalStore,
  } = useStore();
  const { PassStore } = useStore();
  const { PassResetear, loading } = PassStore;
  //const {CATCoursesInfo,testing} = CuotasStore;

  const [ResetPassMod] = useState<ResetPassModFormValues>(
    new ResetPassModFormValues()
  );

  const lowercaseRegex = /(?=.*[a-z])/;
  const uppercaseRegex = /(?=.*[A-Z])/;
  const numericRegex = /(?=.*[1-9])/;
  const caracterRegex = /(?=.*[@$!%*#?&%-/])/;

  let history = useHistory();
  var currentLocation = document.location;

  const urlparamst = new URLSearchParams(String(currentLocation));

  const validationSchema = Yup.object({
    password: Yup.string()
      .min(8, "Se requieren al menos 8 caracteres, un caracter especial y un número")
      .matches(lowercaseRegex, "Debe incluir letras minusculas")
      .matches(uppercaseRegex, "Debe incluir al menos una letra mayuscula")
      .matches(numericRegex, "Debe incluir al menos un numero")
      .matches(caracterRegex, "Debe incluir al menos un caracter especial")
      .required("La contraseña es obligatoria"),

    passwordConfirm: Yup.string()
      .required("La confirmación es obligatoria")
      .oneOf([Yup.ref("password")], "Las Contraseñas no coinciden"),
  });

  function handleFormSubmit(ResetPassMod: ResetPassModFormValues) {
    let tokens: any = urlparamst.get("token")?.split(" ").join("+");
    let emails: any = urlparamst.get("email");
    let newPass: ResetPassMod = {
      token: tokens,
      email: emails,
      password: ResetPassMod.password,
    };
    
    const refreshPage = ()=>{
      window.location.reload();
    }

    PassResetear(newPass).then(() => {
      
      setTimeout(() => {
        toast.success("Contraseña cambiada exitosamente");
        history.push(``);
        refreshPage();
      }, 4000);
      
    });
  }

  if (PassStore.loadingInitial)
    return <LoadingComponent content="Cargando..." />;

  return (
    <Formik
      enableReinitialize
      initialValues={ResetPassMod}
      onSubmit={(values) => handleFormSubmit(values)}
      validationSchema={validationSchema}
    >
      {({ handleSubmit, isValid, errors, isSubmitting, dirty }) => (

        <>

        <Form className=".modal_pago_convenio" onSubmit={handleSubmit} autoComplete="off">

          <div className="reset-password-body">
            <div className="modal_pago_cur contenido-password-reset">

              <div className="modal_pago_head">
                <h1>Reiniciar contraseña</h1>
                <img src="images/loginap.png" alt="logo" />
              </div>

              <div className="contenido_modal_pago ">
                <p>Ingresa tu nueva contraseña</p>
                <MyTextInput name="password" placeholder="" type="password" className="input-resetp" />

                <p>Repite tu contraseña</p>
                <MyTextInput name="passwordConfirm" placeholder="" type="password" className="input-resetp" />

                <ErrorMessage
                  name="error"
                  render={() => (
                    <Label
                      style={{ marginBottom: 10 }}
                      basic
                      color="red"
                      content={errors}
                    />
                  )}
                />

              <Button
                className="button primary"
                disabled={!isValid || !dirty || isSubmitting}
                loading={isSubmitting}
                content="Cambiar contraseña"
                type="submit"
              />
              </div>

            </div>
          </div>

          </Form>

          {/* <Form className=".modal_pago_convenio" onSubmit={handleSubmit} autoComplete="off">
            <div className="contentL">

              <div className="reinicio_password-content">
                <div className="login">

                  <div className="titulos">
                  
                    <img src="images/loginap.png" alt="logo" />
                  </div>

                  <div className="datos">
                    
                    <MyTextInput name="password" placeholder="" type="password" />
                    
                    <Header
                      className="datos1"
                      size="small"
                      content="Vuelva a ingresar la contraseña"
                    />

                    <MyTextInput
                      name="passwordConfirm"
                      placeholder=""
                      type="password"
                    />

                    <ErrorMessage
                      name="error"
                      render={() => (
                        <Label
                          style={{ marginBottom: 10 }}
                          basic
                          color="red"
                          content={errors}
                        />
                      )}

                    />
                  </div>
                  <br></br>
                  <Button
                    className="button"
                    disabled={!isValid || !dirty || isSubmitting}
                    loading={isSubmitting}
                    style={{ backgroundColor: "#15b3e8", color: "white" }}
                    content="Cambiar contraseña"
                    type="submit"
                    fluid
                  />
                </div>
              </div>
            </div>
          </Form> */}

        </>

      )}
    </Formik>
  );
});
